<template>
    <div class="widget knowledge-base-widget">
        <header class="widget-header">
            <h3><i class="fal fa-life-ring purple" /> Knowledge Base</h3>
        </header>

        <div class="widget-body">
            <div ref="articlesWrap" class="articles">
                <div v-if="user.pro" class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">Getting Acquainted with Fusebox</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                The Fusebox Pro subscription comes with three different types of players as well as a transcript plugin. In this Getting Started #3 support doc, we'll walk you through the basic differences between the players, and what the transcript plugin does.<br>
                                <a target="_blank" href="https://support.fusebox.fm/article/51-getting-started-3-using-fusebox">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">Getting Started</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                Start here if you're brand new! Learn how to install your Smart Podcast Player.<br>
                                <a target="_blank" href="https://support.fusebox.fm/category/42-getting-started">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">Fusebox Transcript Plugin</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                The Fusebox Transcript plugin creates a space for you to beautifully display and offer downloads of podcast transcripts on your podcast episode pages. By displaying your podcast transcripts, you enhance your website's SEO and provide your audience an accessibility-friendly way to consume your podcast.<br>
                                <a target="_blank" href="https://support.fusebox.fm/article/264-transcript-plugin">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div v-if="! user.pro" class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">Sticky Player</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                The Sticky Player is one of the three podcast players that comes with your monthly or annual Fusebox Pro subscription. The Sticky Player is similar to the Track Player, in that it plays a single episode of your podcast at a time; it is different in that the Sticky Player is designed specifically to "stick" to the bottom or top of your website.<br>
                                <a target="_blank" href="https://support.fusebox.fm/article/233-sticky-player">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div v-if="! user.pro" class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">How To Troubleshoot Your Shortcode</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                A common reason for the player not appearing correctly is that the shortcode has not been formatted correctly. This happens most often when creating a shortcode from scratch rather than through the classic editor or Gutenberg editor widgets.<br>
                                <a target="_blank" href="https://support.fusebox.fm/article/126-how-to-troubleshoot-your-shortcode">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">How Do I Install the .Zip file to Manually Update My Plugin?</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                Each time we upgrade the Fusebox player files, we send out a notification email. To prompt your site to check for an upgrade, follow the steps in this article: <a href="https://support.fusebox.fm/article/74-how-do-i-upgrade">How do I upgrade my plugin?</a><br>
                                <a target="_blank" href="https://support.fusebox.fm/article/73-how-do-i-install-the-zip-file-to-manually-update-my-plugin">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->

                <div v-if="user.pro" class="article">
                    <h4>
                        <a href="#" @click.prevent="toggleArticle">Highlight Color</a>
                    </h4>
                    <div class="expandable">
                        <div class="article-content">
                            <p>
                                The player's default color is green, but you can customize it to any color that you'd like. You can change the color on a case-by-case basis, but if you plan to use the same color each time, we recommend entering the color into the plugin's default settings.<br>
                                <a target="_blank" href="https://support.fusebox.fm/article/16-change-your-players-color">Read more...</a>
                            </p>
                        </div>
                    </div>
                </div><!-- .article -->
            </div><!-- .articles -->

            <a href="https://support.fusebox.fm" target="_blank">See all articles →</a>
        </div><!-- .widget-body -->
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    /**
     * @returns {Array} Data.
     */
    data() {
        return {
            expandedArticle: null,
        };
    },

    computed: mapState(['user']),

    methods: {
        /**
         * Toggles article.
         *
         * @param  {object} e Event.
         * @returns {void}
         */
        toggleArticle(e) {
            if (this.expandedArticle) {
                this.collapseArticle(this.expandedArticle);
            }

            const article = e.target.closest('.article');

            if (! article.isSameNode(this.expandedArticle)) {
                this.expandArticle(article);
                this.expandedArticle = article;
            } else {
                this.expandedArticle = null;
            }
        },

        /**
         * Expand article.
         *
         * @param  {HTMLElement} item Item to expand.
         * @returns {void}
         */
        expandArticle(item) {
            const expandable = item.querySelector('.expandable');

            if (expandable) {
                expandable.style.maxHeight = `${expandable.scrollHeight}px`;
            }

            item.classList.add('is-expanded');
        },

        /**
         * Collapse article.
         *
         * @param  {HTMLElement} item Item to expand.
         * @returns {void}
         */
        collapseArticle(item) {
            const expandable = item.querySelector('.expandable');

            if (expandable) {
                expandable.style.maxHeight = 0;
            }

            item.classList.remove('is-expanded');
        },
    },
};
</script>
